import React, { useRef } from 'react';
import { Card, Button, Table, Row, Col } from 'react-bootstrap';
import Pdf from 'react-to-pdf';
import './AdmissionTest.scss';

const AdmissionDetailedResultPdf = ({ studentName, branchName, courseName, totalMarks, marksGained, subjectAnalytics, testName, hideDownload }) => {
  const ref = useRef(null);

  const options = {
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4',
  };

  const percentage = totalMarks ? Math.round((marksGained / totalMarks) * 100) : 0;

  return (
    <div className="admission-pdf-container">
      {!hideDownload && (
        <div className="text-right mb-3">
          <Pdf targetRef={ref} options={options} filename={`${studentName || 'Student'}_Result.pdf`}>
            {({ toPdf }) => (
              <Button variant="primary" onClick={toPdf}>
                <i className="fas fa-file-pdf mr-2"></i> Download Detailed Report
              </Button>
            )}
          </Pdf>
        </div>
      )}

      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div className="pdf-document text-left" ref={ref} style={{ width: '210mm', padding: '50px', background: 'white', color: '#333', margin: '0', overflow: 'visible', fontFamily: "'Inter', sans-serif" }}>
          {/* Load Fonts */}
          <style>
            {"@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@700&family=Inter:wght@400;500;600;700&family=Playfair+Display:wght@700&display=swap');"}
          </style>

          <div className="pdf-header mb-5 pb-4 d-flex align-items-center justify-content-between" style={{ borderBottom: '4px double #0f172a' }}>
            <div className="d-flex align-items-center" style={{ gap: '25px' }}>
              <img src="https://support.rizee.in/files/stdomnic1.png" alt="Institute Logo" style={{ height: '120px', objectFit: 'contain' }} />
              <div>
                <h2 style={{ margin: 0, fontFamily: 'Cinzel, serif', fontSize: '28px', color: '#0f172a', letterSpacing: '1px' }}>ST. DOMINIC'S COLLEGE</h2>
                <p style={{ margin: '5px 0', fontSize: '13px', color: '#475569', fontWeight: '500' }}>Plot No: 45, Academic Avenue, Near Science Center</p>
                <p style={{ margin: '5px 0', fontSize: '13px', color: '#475569', fontWeight: '500' }}>Educational District, State - 500001, India</p>
                <p style={{ margin: '5px 0', fontSize: '13px', color: '#475569' }}><strong>Contact:</strong> +91 999 888 7777 | <strong>Email:</strong> registrar@stdominic.edu</p>
              </div>
            </div>
            <div style={{ textAlign: 'right' }}>
              <div style={{ background: '#0f172a', color: 'white', padding: '8px 15px', fontWeight: '700', fontSize: '14px', letterSpacing: '2px', marginBottom: '10px' }}>ADMISSION TEST</div>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#64748b' }}>RESULT REPORT</div>
            </div>
          </div>

          <Row className="mb-5 align-items-center">
            <Col xs={7}>
              <div style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', marginBottom: '5px' }}>Student Name</div>
              <h3 style={{ margin: 0, fontFamily: 'Playfair Display, serif', fontSize: '26px', color: '#0f172a' }}>{studentName || 'Student'}</h3>
            </Col>
            <Col xs={5} className="text-right">
              <div style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', marginBottom: '5px' }}>Report Date</div>
              <div style={{ fontSize: '16px', fontWeight: '600', color: '#1e293b' }}>{new Date().toLocaleDateString('en-IN', { day: '2-digit', month: 'long', year: 'numeric' })}</div>
            </Col>
          </Row>

          <Row className="mb-5">
            <Col xs={4}>
              <div style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', marginBottom: '5px' }}>Branch</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>{branchName || 'N/A'}</div>
            </Col>
            <Col xs={4}>
              <div style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', marginBottom: '5px' }}>Course/Class</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>{courseName || 'N/A'}</div>
            </Col>
            <Col xs={4} className="text-right">
              <div style={{ color: '#94a3b8', fontSize: '11px', textTransform: 'uppercase', fontWeight: '700', marginBottom: '5px' }}>Test Identifier</div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>{testName || 'Detailed Score Report'}</div>
            </Col>
          </Row>

        <Card className="mb-4 shadow-sm border-0 bg-light">
          <Card.Body className="text-center py-4">
            <h2 className="mb-0 text-primary">{marksGained} <span className="text-muted" style={{ fontSize: '1.2rem' }}>/ {totalMarks}</span></h2>
            <p className="mb-0 text-muted mt-2">Overall Score ({percentage}%)</p>
          </Card.Body>
        </Card>

        <h5 className="mb-3">Subject-wise Performance</h5>
        {subjectAnalytics && subjectAnalytics.length > 0 ? (
          <Table bordered className="subject-wise-table">
            <thead className="thead-light">
              <tr>
                <th>Subject</th>
                <th className="text-center">Correct</th>
                <th className="text-center">Wrong</th>
                <th className="text-center">Unattempted</th>
                <th className="text-right">Marks Gained</th>
                <th className="text-right">Total Marks</th>
              </tr>
            </thead>
            <tbody>
              {subjectAnalytics.map((sub, index) => (
                <tr key={index}>
                  <td><strong>{sub.subject_name}</strong></td>
                  <td className="text-center text-success">{sub.correct}</td>
                  <td className="text-center text-danger">{sub.wrong}</td>
                  <td className="text-center text-warning">{sub.unattempted}</td>
                  <td className="text-right"><strong>{sub.marks_gained}</strong></td>
                  <td className="text-right text-muted">{sub.total_marks}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <div className="alert alert-info text-center py-4">
            Subject-wise analytics are not available for this session yet.
          </div>
        )}

          <div className="pdf-footer mt-5 pt-3 border-top text-center text-muted" style={{ fontSize: '12px' }}>
            <p>Generated by Rizee Admission Portal</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmissionDetailedResultPdf;
